import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class CategoryStore extends StoreModel {
    constructor() {
        super('category', {
            namePlural: 'categories',
            sort: 'sort,groupno',
            api: {
                search: {
                    url: '/api/categories/',
                    params: {
                        extendedView: 1,
                        brand: 'all',
                        level: 'all',
                        limit: 15,
                        sort: 'sort,groupno',
                    },
                },
                load: {
                    url: '/api/categories/',
                    params: {},
                },
                save: {
                    url: '/api/categories/by-id/',
                    params: {},
                },
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms',
            },
        });
    }

    @observable category = {};

    @observable categories = [];

    @observable categoryTree = [];

    @observable categoryView = util.getObject('categoryCategoryView') || {};

    getElement(idx) {
        const index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            groupno: this.searchResults[index].groupno,
        };
    }

    @action
    updateTree(categories) {
        this.categoryTree = categories;
    }

    @action
    updateCategoryView(categoryView, value) {
        if (typeof categoryView === 'string' || typeof categoryView === 'number') {
            this.categoryView[categoryView] = typeof value === 'undefined' ? !this.categoryView[categoryView] : value;
            if (!this.categoryView[categoryView]) {
                delete this.categoryView[categoryView];
            }
        } else {
            this.categoryView = categoryView;
        }
        util.setObject('categoryCategoryView', this.categoryView);
    }

    async tree() {
        const response = await util.fetchApi('/api/categories/', { publish: true }, {
            extendedView: 1,
            offset: this.offset,
            limit: this.limit,
            sort: this.sort,
            tree: 1,
            brand: this.queryFilter.brand,
            status: this.queryFilter.status,
            showall: this.queryFilter.showall,
        });
        if (response.status < 300) {
            this.updateTree(response.data);
        }
    }
}

const store = new CategoryStore();
export default store;



// WEBPACK FOOTER //
// ./stores/category.js